import { ControlLayout } from 'components/ControlLayout';
import { LoadingModal } from 'components/response/LoadingModal';
import { ContactForm } from 'components/single-form-view/contact/ContactForm';
import { DATA_LAYER_RESPONSE_KEY } from 'constants/DataLayers';
import { RESPONSE_PATH, RESPONSE_VIEW_ERROR, RESPONSE_VIEW_CONTACTO } from 'constants/ResponseType';
import { FormContext } from 'context/FormContext';
import { useContactServices } from 'hooks/useContactService';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { StorageServiceImpl } from 'services/storage-service/StorageServiceImpl';
import checkIsMobile from 'utils/CheckIsMobile';
import { useLogin } from 'hooks/useLogin';
import { useFormData } from '../hooks/useFormData';

export const ContactContainer = () => {
	const history = useHistory();
	const [enableButton, setEnableButton] = useState(true);
	const [showLoadingModal, setShowLoadingModal] = useState(false);
	const [login] = useLogin();
	const [formData, setformData] = useState<any>({});
	const { formatFormData, setInitialVariablesForm } = useFormData();
	const storageService = new StorageServiceImpl();

	const { sendContact } = useContactServices();

	const classContainer = checkIsMobile()
		? 'portabilidad-container'
		: 'portabilidad-container card-box';

		useEffect(
			() => {
				setShowLoadingModal(true);
				login(
					() => setShowLoadingModal(false),
					() => history.push(`${RESPONSE_PATH}/${RESPONSE_VIEW_ERROR}/error`)
				);
			},
			//eslint-disable-next-line
			[]
		);

	return (
		<div className={classContainer}>
			<FormContext.Provider
				value={{
					setError: setEnableButton,
					setData: setformData,
					storage: storageService,
				}}
			>
				<LoadingModal showLoadingModal={showLoadingModal} />
				<ContactForm />
				<ControlLayout
					inputError={enableButton}
					handleBackClick={() => {window.location.href = 'https://www.crediautos.cl/credito-automotriz/';}}
					handleNextClick={() => {
						setShowLoadingModal(true);
						setformData(setInitialVariablesForm(formData));
						sendContact(formatFormData(formData))
							.then((response) => {
								const { data } = response;								
								sessionStorage.setItem('contact', JSON.stringify(data));
								history.push(
									`${RESPONSE_PATH}/${RESPONSE_VIEW_CONTACTO}/${DATA_LAYER_RESPONSE_KEY.LOAN_NORMAL_SOLICITUD_ENVIADA}`
								);
								
							})
							.catch(() => {
								history.push(`${RESPONSE_PATH}/${RESPONSE_VIEW_ERROR}/error`);
							});
							setShowLoadingModal(false);
					}}
					buttonBackName="Volver"
					buttonNextName="Continuar"
				/>
			</FormContext.Provider>
		</div>
	);
};
